<template>
  <v-container class="Profil">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <v-toolbar  v-if="item" class="my-md-auto " elevation="0" rounded="lg">
      <v-toolbar-title  class="hidden-md-and-down">
          <h2><v-icon large class="mr-2"  >mdi-account</v-icon>{{ item['login'] }}</h2>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-btn
          class="ml-2"
          :to="{ name: 'UserShow' , params: { id: item['@id'] }}"
        >
          {{ $t('global.back')}}
        </v-btn>
      </div>
    </v-toolbar>

    <div  v-if="item">
      <br>
      <p class="ml-4">{{ $t('administration.user.initpasswordconfirm') }}
      </p>
      <p class="ml-4">{{ $t('administration.user.passwordtemp') }}: <strong class="ml-4">{{ passwordTemp }}</strong>
      </p>
    </div>
    </v-sheet>
      <Loading :visible="isLoading" />
  </v-container>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';

const servicePrefix = 'User';

export default {
  name: 'UserInitPasswordConfirm',
  servicePrefix,
  components: {
      Loading,
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('user', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('user', ['find']),
    passwordTemp () {
      return this.$route.params.passwordtemp;
    }
  },
  methods: {
    ...mapActions('user', {
      deleteItem: 'del',
      reset: 'reset',
      update: 'update',
      retrieve: 'load'
    })
  }
};
</script>
